export const imageURLs = {
    "DOC_WITH_STAMP_PATH": "https://procmart-dev.s3.ap-south-1.amazonaws.com/requirementSourceDocument/0370048a-e0db-4fa2-9ef9-ab84df0af52a.png",
    "NO_IMAGE_PATH": "https://procmart-tech.s3.ap-south-1.amazonaws.com/app-images/no_image_no_pg+(6).png"
}